import { Text } from "~/components/text";
import type { SearchSuggestion } from "~/pages/home/types";
import { SearchSuggestionItem } from "./search-suggestion-item";

interface SearchSuggestionListProps {
  title: string;
  items: (SearchSuggestion & { groupTitle: string })[];
  onItemClick: (type: string, searchQuery: string) => void;
  selectedItem?: SearchSuggestion & { groupTitle: string };
}

export const SearchSuggestionList = ({
  title,
  items,
  onItemClick,
  selectedItem,
}: SearchSuggestionListProps) => {
  return (
    <div className="px-1">
      <Text as="span" variant="metricCaption" className="uppercase px-2">
        {title}
      </Text>
      <div className="flex flex-col gap-y-1">
        {items.map((item) => {
          const isSelected = selectedItem === item;
          return (
            <SearchSuggestionItem
              key={`${item.type}-${item.title}`}
              {...item}
              onClick={() => onItemClick(item.type, item.value)}
              isSelected={isSelected}
            />
          );
        })}
      </div>
    </div>
  );
};
